import { useContext } from 'react';
import dependencyManagerContext from '../../../contexts/dependencyManager/dependencyManagerContext';
import * as T from '../../../contexts/dependencyManager/types';

const useDependencyManagerContext = (): T.DependencyManagerContextType =>
  useContext(dependencyManagerContext);

export default useDependencyManagerContext;
